/* global AFRAME */

AFRAME.registerComponent('set-raycaster-objects', {
  schema: {
    on: {type: 'string'},
    target: {type: 'selector'},
    objects: {type: 'string'}
  },

  multiple: true,

  init: function () {
    var data = this.data;
    var el = this.el;

    el.addEventListener(data.on, function () {
      data.target.setAttribute('raycaster', 'objects', data.objects);
    });
  }
});



// WEBPACK FOOTER //
// ./js/components/change-raycaster.js